const API_URL = 'https://api-dashboard.getsensync.com/api/sparing';
// const API_URL = 'http://localhost:3000/api/sparing';

export { API_URL };
